/* eslint-disable @typescript-eslint/no-duplicate-enum-values */ export const ALL_COLORS = [
    'blue',
    'gray',
    'cyan',
    'cool-gray',
    'green',
    'magenta',
    'purple',
    'red',
    'teal',
    'yellow'
];
export const ALL_COLORS_WITHOUT_GRAY = [
    'blue',
    'cyan',
    'green',
    'magenta',
    'purple',
    'red',
    'teal',
    'yellow'
];
/* NOTE:: Do not add  yellow or teal to available colors */ export const AVAILABLE_SPACE_COLORS = [
    'blue',
    'cyan',
    'green',
    'magenta',
    'purple',
    'red'
];
export const GanttBarColors = [
    'blue',
    'green',
    'magenta',
    'cyan',
    'purple',
    'teal'
];
export var StatusColors = /*#__PURE__*/ function(StatusColors) {
    StatusColors["Blocked"] = "var(--red-60)";
    StatusColors["Cancelled"] = "var(--cool-gray-40)";
    StatusColors["Completed"] = "var(--green-40)";
    StatusColors["Default"] = "var(--cool-gray-40)";
    StatusColors["InPlanning"] = "var(--purple-60)";
    StatusColors["InProgress"] = "var(--green-60)";
    StatusColors["Proposed"] = "var(--blue-40)";
    StatusColors["ToBeStaffed"] = "var(--orange-40)";
    StatusColors["ToDo"] = "var(--blue-40)";
    return StatusColors;
}({});
export const SmartFillTagColors = ALL_COLORS.filter((_color)=>![
        'blue',
        'gray',
        'cool-gray'
    ].includes(_color));
